const BORDER_COLOR = ['rgba(0, 202, 234,1)', 'rgba(225, 192, 147,1)', 'rgba(222, 160, 160,1)', 'rgba(162, 215, 160,1)']
const BACKGROUND_COLOR = [
    'rgba(0, 202, 234,.175)',
    'rgba(225, 192, 147,.175)',
    'rgba(222, 160, 160,.175)',
    'rgba(162, 215, 160,.175)',
]

// intended to be used in non-reactive situations
// to manage the colors used on a chart
class ChartColorCache {
    constructor() {
        this.clear()
    }

    getColors(key) {
        let colors = this._cache[key]

        if (!colors) {
            this._cache[key] = colors = {
                backgroundColor: BACKGROUND_COLOR[this._index % BACKGROUND_COLOR.length],
                borderColor: BORDER_COLOR[this._index % BORDER_COLOR.length],
            }

            this._index++
        }

        return colors
    }

    clear() {
        this._index = 0
        this._cache = {}
    }
}

export default ChartColorCache
